module.exports = __webpack_public_path__ + "img/legalXchain_img.729a7a85.png";